import { render, staticRenderFns } from "./EmptyOrgSettingsState.vue?vue&type=template&id=62588748&"
import script from "./EmptyOrgSettingsState.vue?vue&type=script&lang=js&"
export * from "./EmptyOrgSettingsState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports